import { Component } from '@angular/core';
import { MainButtonComponent } from '../../shared/ui/main-button/main-button.component';
import { StoreService } from '../../store/store.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [MainButtonComponent],
})
export class LoginComponent {
  constructor(private readonly store: StoreService) {}

  login() {
    const {
      auth: { redirectToLogIn },
    } = this.store.getActions();
    redirectToLogIn();
  }
}
